// extracted by mini-css-extract-plugin
module.exports = {"card":"BrandCard_card__c0BZs","copyCard":"BrandCard_copyCard__1rYF-"};